import { BrowserModule } from '@angular/platform-browser';
import { Injector, NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { MainComponent } from './pages/main/main.component';
import { LoginComponent } from './pages/login/login.component';
import { HeaderComponent } from './pages/main/header/header.component';
import { FooterComponent } from './pages/main/footer/footer.component';
import { MenuSidebarComponent } from './pages/main/menu-sidebar/menu-sidebar.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DashboardComponent } from './views/dashboard/dashboard.component';
import { ToastrModule } from 'ngx-toastr';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerModule } from 'ngx-spinner';
import { NgxPaginationModule } from 'ngx-pagination';
import {
  registerLocaleData,
  LocationStrategy,
  HashLocationStrategy,
  DatePipe,
  CommonModule,
} from '@angular/common';
import localeEn from '@angular/common/locales/en';
import { UserDropdownMenuComponent } from './pages/main/header/user-dropdown-menu/user-dropdown-menu.component';
import { HttpClientModule } from '@angular/common/http';

import { DataTablesModule } from 'angular-datatables';
import { CookieService } from 'ngx-cookie-service';
import { TimKiemDonGianComponent } from './pages/tim-kiem-don-gian/tim-kiem-don-gian.component';
import { TimKiemNangCaoComponent } from './pages/tim-kiem-nang-cao/tim-kiem-nang-cao.component';
import { BaoCaoTongHopThuChiComponent } from './pages/bao-cao-tong-hop-thu-chi/bao-cao-tong-hop-thu-chi.component';
import { HoSoHSSVComponent } from './pages/ho-so-hssv/ho-so-hssv.component';
import { HocTapRenLuyenComponent } from './pages/hoc-tap-ren-luyen/hoc-tap-ren-luyen.component';
import { QD5363Component } from './pages/qd5363/qd5363.component';
import { QuaTrinhKhenThuongComponent } from './pages/qua-trinh-khen-thuong/qua-trinh-khen-thuong.component';
import { QuaTrinhKyLuatComponent } from './pages/qua-trinh-ky-luat/qua-trinh-ky-luat.component';
import { ThoiHocNgungHocComponent } from './pages/thoi-hoc-ngung-hoc/thoi-hoc-ngung-hoc.component';
import { ThongTinHocPhiLePhiComponent } from './pages/thong-tin-hoc-phi-le-phi/thong-tin-hoc-phi-le-phi.component';
import { TongHopNoHocPhiKinhPhiComponent } from './pages/tong-hop-no-hoc-phi-kinh-phi/tong-hop-no-hoc-phi-kinh-phi.component';
import { TongHopNoPhiLePhiComponent } from './pages/tong-hop-no-phi-le-phi/tong-hop-no-phi-le-phi.component';
import { TongHopThiLaiHocLaiComponent } from './pages/tong-hop-thi-lai-hoc-lai/tong-hop-thi-lai-hoc-lai.component';
import { XepLoaiDiemHocPhanComponent } from './pages/xep-loai-diem-hoc-phan/xep-loai-diem-hoc-phan.component';
import { XepLoaiHocKyNamHocComponent } from './pages/xep-loai-hoc-ky-nam-hoc/xep-loai-hoc-ky-nam-hoc.component';
import { FacebookLoginProvider, GoogleLoginProvider, SocialAuthServiceConfig, SocialLoginModule } from 'angularx-social-login';
import { LoginSystemComponent } from './pages/login-system/login-system.component';
import { BreadCrumComponent } from './_core/bread-crum/bread-crum.component';
import { TimeTableDetailComponent } from './components/time-table-detail/time-table-detail.component';
import { TimeTableDetailService } from './components/time-table-detail/time-table-detail.service';
import { NgSelectModule } from '@ng-select/ng-select';
import { TraCuuCongViecGiangDayComponent } from './pages/tra-cuu-cong-viec-giang-day/tra-cuu-cong-viec-giang-day.component';
import { ThongKeNhapHocComponent } from './pages/thong-ke-nhap-hoc/thong-ke-nhap-hoc.component';
import { ThongKeNhapHocMasterComponent } from './pages/thong-ke-nhap-hoc-master/thong-ke-nhap-hoc-master.component';
import { ThongKeNhapHocSPComponent } from './pages/thong-ke-nhap-hoc-sp/thong-ke-nhap-hoc-sp.component';
import { NoteBookClassComponent } from './pages/note-book-class/note-book-class.component';
import { TablefiltercbComponent } from './Pipe/tablefiltercb/tablefiltercb.component';
import { FilterClassComponent } from './Pipe/filter-class/filter-class.component';
import { NotebookComponent } from './pages/notebook/notebook.component';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { TraCuuNhanXetGiangDayComponent } from './pages/tra-cuu-nhan-xet-giang-day/tra-cuu-nhan-xet-giang-day.component';
import { TraCuuNhanXetChiTietComponent } from './pages/tra-cuu-nhan-xet-chi-tiet/tra-cuu-nhan-xet-chi-tiet.component';

registerLocaleData(localeEn, 'en-EN');

@NgModule({
  declarations: [
    AppComponent,
    MainComponent,
    LoginComponent,
    HeaderComponent,
    FooterComponent,
    MenuSidebarComponent,
    DashboardComponent,
    UserDropdownMenuComponent,
    TimKiemDonGianComponent,
    TimKiemNangCaoComponent,
    BaoCaoTongHopThuChiComponent,
    HoSoHSSVComponent,
    HocTapRenLuyenComponent,
    QD5363Component,
    QuaTrinhKhenThuongComponent,
    QuaTrinhKyLuatComponent,
    ThoiHocNgungHocComponent,
    ThongTinHocPhiLePhiComponent,
    TongHopNoHocPhiKinhPhiComponent,
    TongHopNoPhiLePhiComponent,
    TongHopThiLaiHocLaiComponent,
    XepLoaiDiemHocPhanComponent,
    XepLoaiHocKyNamHocComponent,
    LoginSystemComponent,
    BreadCrumComponent,
    TimeTableDetailComponent,
    TraCuuCongViecGiangDayComponent,
    ThongKeNhapHocComponent,
    ThongKeNhapHocMasterComponent,
    ThongKeNhapHocSPComponent,
    NoteBookClassComponent,
    TablefiltercbComponent,
    FilterClassComponent,
    NotebookComponent,
    TraCuuNhanXetGiangDayComponent,
    TraCuuNhanXetChiTietComponent
  ],
  imports: [
    HttpClientModule,
    BrowserModule,
    AppRoutingModule,
    DataTablesModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    NgxSpinnerModule,
    ToastrModule.forRoot({
      timeOut: 5000,
      positionClass: 'toast-top-right',
      preventDuplicates: true,
    }),
    NgbModule,
    HttpClientModule,
    FormsModule,
    SocialLoginModule,
    CommonModule,
    NgSelectModule,
    NgxPaginationModule,
    CKEditorModule
  ],
  providers: [
    CookieService,
    DatePipe,
    TimeTableDetailService,
    {
      provide: LocationStrategy, useClass: HashLocationStrategy
    },
    {
      provide: 'SocialAuthServiceConfig',
      useValue: {
        autoLogin: false,
        providers: [
          {
            id: GoogleLoginProvider.PROVIDER_ID,
            provider: new GoogleLoginProvider(
              '129830746409-hah9phs621tvm6ilnragtk8ihnar28fg.apps.googleusercontent.com'
            ),
          }, {
            id: FacebookLoginProvider.PROVIDER_ID,
            provider: new FacebookLoginProvider('230053752158759')
          }
        ],
      } as SocialAuthServiceConfig,
    },
  ],
  bootstrap: [AppComponent],
})

export class AppModule {
  constructor(private injector: Injector) {
    AppInjector = this.injector;
  }
}

export let AppInjector: Injector;
